export enum MemberPreferenceType {
    SHOW_PROFILE_PICTURE = 'SHOW_PROFILE_PICTURE',
    SHOW_MY_CONTACT_ADDRESS = 'SHOW_MY_CONTACT_ADDRESS',
    SHOW_MY_PHONE_NO = 'SHOW_MY_PHONE_NO',
    SHOW_MY_EMAIL = 'SHOW_MY_EMAIL',
    SEND_ME_ANNOUNCEMENTS_TO_MY_MAIL = 'SEND_ME_ANNOUNCEMENTS_TO_MY_MAIL',
    PREFERRED_COMMUNICATION_LANGUAGE = 'PREFERRED_COMMUNICATION_LANGUAGE',
    PREFERRED_LANGUAGE = 'PREFERRED_LANGUAGE',
    RECEIVE_BONUS_RECAP_VIA_EMAIL = 'RECEIVE_BONUS_RECAP_VIA_EMAIL',
    GO_GREEN = 'GO_GREEN',
    PREFERRED_COMMUNICATION = 'PREFERRED_COMMUNICATION',
    TO_BE_CONTACTED_BY_SPONSOR_BY_EMAIL = 'TO_BE_CONTACTED_BY_SPONSOR_BY_EMAIL',
    TO_BE_CONTACTED_BY_SPONSOR_BY_PHONE = 'TO_BE_CONTACTED_BY_SPONSOR_BY_PHONE',
    PRIVACY_PREFERENCE = 'PRIVACY_PREFERENCE',
    NOTIFY_ABOUT_PROMOTIONS_AND_UPDATES = 'NOTIFY_ABOUT_PROMOTIONS_AND_UPDATES'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-preference-type.enum.ts